<template>
  <el-row>
    <el-col :span="24">
      <div>
        <div class="detail_top_info_box">
          <div class="top_info_box">
            <div class="top_info_box_left">
              <video controls :src="university.VideoUrl"></video>
            </div>
            <div class="top_info_box_right">
              <div class="school_logo">
                <img :src="university.LogoUrl" alt />
              </div>
              <div class="school_top"  @click="navigateToUrl">进入官网</div>
              <div class="school_txt_top">
                <img src="@/assets/schoolInfo/school_txt_top.png"/>
              </div>
              <div class="school_txt">
                {{university.Synopsis}}</div>
                <!-- 河南工程学院地处河南省省会郑州市，是经国家教育部批准设立的一所省属公办普通本科院校，是河南省重点建设的“示范性应用技术类型本科院校”、国家发改委立项建设的产教融合实训基地、河南省整体转型发展试点院校、河南省硕士学位授予重点立项培育单位、河南省首批“装配式”建筑人才培训基地、河南省首批“中华优秀文化传承基地”、河南省文明校园、河南省文明校园 -->
                <div class="school_txt2" @click="openMore = true">【展开】
              </div>
              <div class="school_txt_bottom">
                <img src="@/assets/schoolInfo/school_txt_bottom.png"/>
              </div>
              <div class="school_bottom"></div>
              <div class="school_student">
                <img src="@/assets/schoolInfo/student.png"/>
              </div>
            </div>
          </div>

          <div class="bottom_info_box">
            <div class="bottom_info_box_left"></div>
            <div class="bottom_info_box_center">
              <div class="bottom_info_box_center_txt">
                 {{university.CGZHSynopsis}}
               
              </div>
              <div class="box_center_txt" @click="openMore2 = true">【展开】 </div>
            </div>
            <div class="bottom_info_box_right"></div>
          </div>
        </div>
        <div class="detail_body_info_box">
          <div class="detail_body_header">
            <div class="detail_body_header_left">
              <div class="detail_header_icon">
                <img src="@/assets/schoolInfo/icon_header.png"/>
              </div>
              <div class="detail_header_title">技术成果</div>
            </div>
            <div class="detail_body_header_right"><router-link :to="'/fruitt?id='+$route.query.id" class="link_c_gray">
                      查看更多
                    </router-link></div>
          </div>
          <div class="tech_box">
            <div class="tech_item" v-for="(item,index) in jscgList.slice(0, 8)" :key="index">
              <div class="tech_img">
                <img :src="item.PictureUrl"/>
              </div>
              <div class="tech_content">
                <div class="tech_name">{{item.Title}}</div>
                <div class="tech_desc">技术领域：{{item.TechFieldName}}</div>
                <div class="tech_desc">项目阶段：{{item.ProjectPhaseName}}</div>
                <div class="tech_desc">更新时间：{{item.UpdateTime}}</div>
              </div>
              <div class="tech_border"></div>
            </div>
          </div>
        </div>
        <div class="detail_body_info_box">
          <div class="detail_body_header">
            <div class="detail_body_header_left">
              <div class="detail_header_icon">
                <img src="@/assets/schoolInfo/icon_header.png"/>
              </div>
              <div class="detail_header_title">相关技术需求</div>
            </div>
            <div class="detail_body_header_right">
              <router-link  :to="'/demand?id='+$route.query.id" class="link_c_gray">
                      查看更多
                    </router-link>
            </div>
          </div>
          <div class="require_type_box">
            <div class="require_type_item" v-for="(item,index) in TechFieldEnumArr" :key="index" :class="requireParams.TechnicalField == item.ID ? 'require_active' : ''" @click="requireItemClick(item)">
              <div class="require_type_item_txt">{{ item.Title }}</div>
              <div class="require_type_item_icon"><img src="@/assets/schoolInfo/icon_arrow.png"></div>
            </div>
          </div>
          <div class="require_box">
            <div class="require_item" v-for="(item,index) in requireList .slice(0, 9)" :key="index">
              <div class="require_img">
                <img :src="item.PictureUrl"/>
              </div>
              <div class="require_content">
                <div class="require_name">{{ item.Title }}</div>
                <div class="require_desc">预算金额：{{ item.InvestmentAmount }}万元</div>
                <div class="require_desc">更新时间：{{ handleTime(item.UpdateTime) }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="detail_body_info_box">
          <div class="detail_body_header">
            <div class="detail_body_header_left">
              <div class="detail_header_icon">
                <img src="@/assets/schoolInfo/icon_header.png"/>
              </div>
              <div class="detail_header_title">重点研发平台</div>
            </div>
            <div class="detail_body_header_right"><router-link :to="'/research?id='+$route.query.id" class="link_c_gray">
                      查看更多
                    </router-link></div>
          </div>
          <div class="dev_box">
            <div class="dev_item" v-for="(item,index) in yfptList.slice(0, 4)" :key="index">
              <div class="dev_img">
                 <img :src="item.CoverImage"/>
              </div>
              <div class="dev_content">
                <div class="dev_name">{{item.ResearchPlatformName}}</div>
                <div class="dev_name_bar"></div>
                <div class="dev_desc">技术领域：{{item.TechnologyName}}</div>
                <div class="dev_desc">级 别：{{item.RecognizedUnit}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="detail_body_info_box">
          <div class="detail_body_header">
            <div class="detail_body_header_left">
              <div class="detail_header_icon">
                <img src="@/assets/schoolInfo/icon_header.png"/>
              </div>
              <div class="detail_header_title">科研/成果转化专家</div>
            </div>
            <div class="detail_body_header_right">
              <router-link :to="'/creativeTalents?id='+$route.query.id" class="link_c_gray">
                      查看更多
                    </router-link>
            </div>
          </div>
          <div class="expert_box">
            <div class="expert_item" v-for="(item,index) in KYZJList .slice(0, 4)" :key="index">
              <div class="expert_img">
                <img :src="item.CoverImage"/>
              </div>
              <div class="expert_content">
                <div class="expert_name">{{item.FullName}}<span>教授</span></div>
                <div class="expert_name_bar"></div>
                <div class="expert_desc_box">
                  <div class="expert_desc" >技术领域：{{item.ResearchField}}</div>
                  <div class="expert_desc" >研究方向：{{item.Direction}}</div>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div class="detail_bottom_info_box">
          <div class="detail_bottom_info_box_body">
            <div class="detail_bottom_info_box_left" v-for="(item,index) in SPList .slice(0, 1)" :key="index">
              <div class="detail_bottom_info_box_left_video">
                <video controls :src="url"></video>
              </div>
              <div class="detail_bottom_info_box_left_name">{{item.name}}</div>
              <div class="detail_bottom_info_box_left_time">发布时间：{{item.createDate}} <span>播放量：{{item.PlaybackVolume}}</span></div>
              <div class="detail_bottom_info_box_left_txt">{{item.speakerIntroduction}}</div>
              <div class="detail_bottom_info_box_left_enter">点击进入详情<span></span></div>
            </div>
            <div class="detail_bottom_info_box_right">
              <el-scrollbar class="scrollbar_bottom">
                <div class="bottom_info_box_item" v-for="(item,index) in SPList " :key="index">
                  <div class="bottom_info_box_item_left">
                    <video controls :src="url"></video>
                  </div>
                  <div class="bottom_info_box_item_right">
                    <div class="bottom_info_box_item_right_name">{{item.name}}</div>
                    <div class="bottom_info_box_item_right_desc">发布时间：{{item.createDate}}</div>
                    <div class="bottom_info_box_item_right_desc">播 放 量 ：{{item.PlaybackVolume}}</div>
                  </div>
                </div>
              </el-scrollbar>
            </div>
          </div>
        </div>

      </div>
    </el-col>
    <el-dialog :visible.sync="openMore" custom-class="open_more_dialog_box" width="58.75rem">
      <div class="open_more_dialog">
        <div class="open_more_dialog_top">
          <div class="open_more_dialog_name">学院简介</div>
        </div>
        <div class="open_more_dialog_body">
          <el-scrollbar class="scrollbar_dialog">
            <div class="dialog_body_txt">
             {{university.Synopsis}}
            </div>
          </el-scrollbar>
        </div>
        <div class="open_more_dialog_footer">
          <div class="open_more_dialog_btn" @click="openMore = false">关闭</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="openMore2" custom-class="open_more_dialog_box" width="58.75rem">
      <div class="open_more_dialog">
        <div class="open_more_dialog_top">
          <div class="open_more_dialog_name">成果转化工作介绍</div>
        </div>
        <div class="open_more_dialog_body">
          <el-scrollbar class="scrollbar_dialog">
            <div class="dialog_body_txt">
              {{university.CGZHSynopsis}}
            </div>
          </el-scrollbar>
        </div>
        <div class="open_more_dialog_footer">
          <div class="open_more_dialog_btn" @click="openMore2 = false">关闭</div>
        </div>
      </div>
    </el-dialog>
  </el-row>
</template>

<script>
import {getAction, postAction} from "@/api/api";
import empty from "@/components/empty.vue";
import Pagination from "../components/Pagination/paginationpro.vue";
import qs from "qs";
import {fruitChoose, library, CollegesHandler, InnovativeTalentsHandle,VideoLectureHallHandle} from "@/api/url";

export default {
  name: "Organization",
  data() {
    return {
      //转换第一帧
      // cutPicture(item) {
      //   let video = document.createElement("video");
      //   video.style = 'position:fixed; top: 9999px;left:9999px;z-index:-9999'
      //   video.preload = 'metadata'
      //   video.currentTime = 1   //截取的视频第一秒作为图片
      //   video.src = item.videoUrl
      //   video.setAttribute('crossOrigin', 'anonymous');
      //   video.width = 113
      //   video.height = 75
      //   document.body.appendChild(video)
      //   video.onloadeddata = function () {
      //     let canvas = document.createElement('canvas')
      //     canvas.width = 113
      //     canvas.height = 75
      //     canvas.getContext('2d').drawImage(video, 0, 0, video.clientWidth, video.clientHeight)
      //     var oGrayImg = canvas.toDataURL('image/jpeg');
      //     item.videoUrl = oGrayImg
      //     this.remove()
      //   }
      //   return item
      // },
      headList: [], 
      //人才库参数
      taleget: {
        action: "Get_CollegeRegInfo_v1",
        pageSize: 12,
        page: 1,
        limit: 16,
        Title: "",
        sort: "C.CreationDate DESC"
      },

      total: 0,
      //人才库列表
      itemList: [],
      total: 1,
      sortA: false, //综合排序
      talrowetList: [], //热门成果
      talcltList: [], //热门需求
      searchForm: {
        action: "Get_AchievementList",
        pageSize: 10, //一页多少条
        page: 1, //	第几页
        strSort: "", // 	//发布时间 上 a.UpdateTime ASC //发布时间 下 a.UpdateTime DESC //热度 上 b.ClickRank ASC //热度 下 b.ClickRank DESC //金额 上 a.InvestInFunds ASC //金额 下 a.InvestInFunds DESC
        strTechFieldEnum: "", //	技术领域id
        strPropertystatus: "", //	知识产权状况id
        strProjectPhase: "", //	项目阶段id
        strCooperaType: "", //	合作方式id
        strBudgetary: "", //	投入资金id
        strtitle: "", // 	搜索关键字
        strCountries: "", //	0：国内 1：国外
        strCitys: "", //	国内-省市ID
        strCountryText: "", //	国外-国家ID
      },
      TechFieldEnumArr: [],
      TechA: null, // 技术激活
      openLineTech: false, // 技术展开
      KonwA: "", // 技术激活
      LogoUrl: "",
      VideoUrl: "",
      CollegesUniversitiesName: "",
      EducationalLevel: "",
      EducationalType: "",
      Synopsis: "",
      tjiu: null, //技术库
      child: null, //国家
      sortin: null, //排序
      istrue: false, //时间排序
      isroung: false, //热度排序
      openMore:false,
      openMore2:false,
      videoUrl:'',
      university:{},
      devList:[],
      TechFieldEnumArr:[],
      requireList:[],
      jscgList:[],
      yfptList:[],
      KYZJList:[],
      SPList:[],
      requireParams:{
        action:'GetCollegesDemandPageList',
        id:this.$route.query.id,
        page:1,
        limit:9,
        TechnicalField:''
      },
   jsParams:{
    action:'GetCollegesAchievementByID',
    id:this.$route.query.id,
    page:1,
        limit:8,
   },
   ptParams:{
    action:'GetPlatFormByCollegesIdList',
    id:this.$route.query.id,
    page:1,
        limit:8,
   },
   zjParams:{
    action:'GetPageListByPC',
    Field:'',
    page:1,
    order:'r.CreatorDate desc',
    CollegesUniversitiesGUID:this.$route.query.id,
        limit:8,
   },
   spParams:{
    action:'GetPageListPC',
    name:'',
    page:1,
    sort:'ah.createDate DESC',
    CollegesUniversitiesGUID:this.$route.query.id,
        limit:8,
   }

    };
  },
  props: {},
  components: {
    Pagination,
    empty,
  },
  created() {
    // this.$bus.$emit("ChangeFocus", 3);
    // window.localStorage.setItem("NowIndex", 5);
    // if (this.$route.query.type) {
    //   this.TechA = this.$route.query.type;
    //   this.taleget.strTechField = this.$route.query.type;
    // }
    // console.log("+++++++", this.taleget.pageSize);
    //列表
    // this.talentList();
    debugger
    this.taleget.id = this.$route.query.id
    this.head()
    this.getRequireList()
    this.getDevList()
    this. getYFPTList()
    this. getJSCGList()
    this. getKYZJList()
    this. getSPList()
    this.getTechFieldEnum()
    // this.$bus.$emit('ChangeFocus', 3)
    //   window.localStorage.setItem('NowIndex', 3)
    //   if (this.$route.query.type) {
    //     this.TechA = this.$route.query.type
    //     this.taleget.strTechField = this.$route.query.type
    //   }
    //   console.log('+++++++',this.taleget.pageSize)
    //   //列表
    //   this.talentList()
    //   //热门成果
    //   this.talrowet()
      
    //   //热门需求
    //   this.talclt()
      //lost
    //lost
  },
  mounted() {
    // this.$bus.$on("LoginSuccess", (e) => {
    //   if (e) {
    //     this.talentList();
    //   }
    // });
    // this.getChoose();
  },
  methods: {
    navigateToUrl() {
      
      this.getAction(CollegesHandler, {action:'Get_CollegeRegInfo_v1',id:this.$route.query.id}).then(url => {
        window.location.href = SchoolWebsite;
      }).catch(error => {
        console.error('Error fetching redirect URL:', error);
      });
    },
   
    requireItemClick(item){
      this.requireParams.TechnicalField = item.ID
      this.getRequireList()
    },
    //搜索清除
    clearVal() {
      this.talentList();
    },
    recomSort(n) {
      this.sortin = n;
      this.taleget.strSort = "";
      this.isroung = false;
      this.istrue = false;
      this.talentList();
    }, // 综合排序
    timeSort(n) {
      this.sortin = n;
      this.istrue = !this.istrue;
      if (this.istrue) {
        this.taleget.strSort = "a.UpdateDate DESC";
      } else {
        this.taleget.strSort = "a.UpdateDate ASC";
      }
      this.isroung = false;
      this.talentList();
    }, //时间排序
    hotSort(n) {
      this.sortin = n;
      this.isroung = !this.isroung;
      if (this.isroung) {
        this.taleget.strSort = " a.ClickRank DESC";
      } else {
        this.taleget.strSort = " a.ClickRank ASC";
      }
      this.istrue = false;
      this.talentList();
    }, // 热度排序
    // 切换计划标签
    changeTech(item) {
      this.TechA = item;
      this.taleget.strTechField = item;
      this.taleget.page = 1;
      this.talentList();
    },
    // 技术更多
    openMoreTech() {
      this.openLineTech = !this.openLineTech;
    },
    getTechFieldEnum() {
      let data = {
        action: "Achievements_getfields",
        ParentName: "TechFieldEnum",
      };
      this.TechFieldEnumArr = []
      getAction(fruitChoose, data).then((res) => {
        res.map((item) => {
          this.TechFieldEnumArr.push(item);
        });
      });
    },
    //视频讲堂
    getSPList(){
      getAction(VideoLectureHallHandle, this.spParams).then((res) => {
        this.SPList = res.data;
      });
    },
    //科研专家
    getKYZJList(){
      getAction(InnovativeTalentsHandle, this.zjParams).then((res) => {
        this.KYZJList = res.data;
      });
    },
    //研发平台
    getYFPTList(){
      getAction(CollegesHandler, this.ptParams).then((res) => {
        this.yfptList = res.data;
      });
    },
    //技术成果
    getJSCGList(){
      getAction(CollegesHandler, this.jsParams).then((res) => {
        this.jscgList = res.data;
      });
    },
    //相关需求
    getRequireList(){
      getAction(InnovativeTalentsHandle, this.requireParams).then((res) => {
        this.requireList = res.data;
      });
    },
    handleTime(time){
      if(time){
        return time.substring(0,10)
      }
      return ''
    },
    
    getDevList(){
      getAction(CollegesHandler, {action:'GetPlatFormByCollegesIdList',id:this.$route.query.id,page:1,limit:4}).then((res) => {
        this.devlist = res.data;
      });
    },
    //数据列表
    talentList() {
      for (let i = 0; i < 10; i++) {
        this.itemList.push({
          ID: i,
          LogoUrl: 'https://images.shobserver.com/news/690_390/2024/01/23/l_cb20240123170403602052.jpg'
        })
      }
      getAction(CollegesHandler, this.taleget).then((res) => {
        this.itemList = res.data;
        this.total = res.count;
      });
    },
    head() {
      getAction(CollegesHandler, {action:'Get_CollegeRegInfo_v1',id:this.$route.query.id}).then((res) => {
        this.university = res;
      });
    },
    //专家库
    tquan(n) {
      this.tjiu = n;
      this.taleget.page = 1;
      if (n == null) {
        this.taleget.strCategory = "";
        this.talentList();
        return;
      }
      this.taleget.strCategory = n;
      this.talentList();
    },
    //国家
    chilerd(int) {
      this.child = int;
      this.taleget.page = 1;
      if (int == null) {
        this.taleget.strprovince = "";
        this.talentList();
        return;
      }
      this.taleget.strprovince = int;
      this.talentList();
    },
    //搜索
    hadsoun() {
      this.talentList();
      this.$refs.basicInformation.scrollIntoView({
        behavior: "smooth", // 平滑过渡
        block: "start", // 上边框与视窗顶部平齐。默认值
      });
    },
    //搜索回车事件
    keyup() {
      let evt = window.event.keyCode;
      if (evt == 13) {
        this.talentList();
      }
    },
    //成果跳转详情
    talent(id) {
      //判断是否是PC设备，true是，false不是
      let userAgentInfo = navigator.userAgent;
      let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPod"];
      let flag = true;
      for (let j = 0; j < Agents.length; j++) {
        if (userAgentInfo.indexOf(Agents[j]) > 0) {
          flag = false;
          break;
        }
      }
      if (window.screen.width >= 768) {
        flag = true;
      }
      if (flag) {
        let routeData = this.$router.resolve({
          path: "/schoolInfo",
          query: {list: id},
        });
        window.open(routeData.href, "_blank");
      } else {
        window.location.href =
            this.Urls + "/Mobile/index.html#/TalentPoolDetail?id=" + id;
        // this.$router.push({
        //   path:
        //     'http://www.nttzzc.com/Mobile/index.html#/TalentPoolDetail?id=' +
        //     id,
        // })
      }
    },
 
    //需求跳转详情
    crtto(id) {
      //判断是否是PC设备，true是，false不是
      let userAgentInfo = navigator.userAgent;
      let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPod"];
      let flag = true;
      for (let j = 0; j < Agents.length; j++) {
        if (userAgentInfo.indexOf(Agents[j]) > 0) {
          flag = false;
          break;
        }
      }
      if (window.screen.width >= 768) {
        flag = true;
      }
      if (flag) {
        let routeData = this.$router.resolve({
          path: "/demandDetail",
          query: {id},
        });
        window.open(routeData.href, "_blank");
      } else {
        window.location.href =
            this.Urls + "/Mobile/index.html#/NeedPoolDetail?id=" + id;
        // this.$router.push({
        //   path:
        //     'http://www.nttzzc.com/Mobile/index.html#/NeedPoolDetail?id=' + id,
        // })
      }
    },

    //成果库跳转
    crttid(item) {
      // console.log(item)
      //判断是否是PC设备，true是，false不是
      let userAgentInfo = navigator.userAgent;
      let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPod"];
      let flag = true;
      for (let j = 0; j < Agents.length; j++) {
        if (userAgentInfo.indexOf(Agents[j]) > 0) {
          flag = false;
          break;
        }
      }
      if (window.screen.width >= 768) {
        flag = true;
      }
      if (flag) {
        let routeData = this.$router.resolve({
          path: "/fruitDetail",
          query: {id: item.ID},
        });
        window.open(routeData.href, "_blank");
      } else {
        window.location.href =
            this.Urls + "/Mobile/index.html#/AchievementDetail?id=" + item.ID;
        // this.$router.push({
        //   path:
        //     'http://www.nttzzc.com/Mobile/index.html#/AchievementDetail?id=' +
        //     item.ID +
        //     '&Score=' +
        //     5,
        // })
      }
    },
    //登陆成功
    LoginSuccess() {
      let data = {
        action: "Get_UserInfo",
      };
      postAction(library, qs.stringify(data)).then((res) => {
        this.RealName = res.RealName;
        window.localStorage.setItem("RealName", res.RealName);
      });
      this.$router.go(0);
    },
  },
  computed: {
    setstrot() {
      return this.istrue;
    },
    setaleget() {
      return this.taleget;
    },
  },
};
</script>

<style lang="scss" scoped>
.head {
  width: 100%;
  height: 10rem;

}

.form {
  width: 45rem;
  height: 2.8rem;
  margin-left: 5.8rem;
  padding-top: 2rem;

  .el-input {
    width: 25rem;

    /deep/ .el-input__inner {
      height: 2.8rem !important;
      padding-left: 1rem;
      font-size: 1rem;
      font-family: Microsoft YaHei;
      font-weight: 400;

      color: #999999;
      opacity: 1;
    }

    /deep/ .el-input__prefix {
      left: 1.25rem;

    }

    /deep/ .el-input-group__append {
      border: none;
    }

    .el-button--color {
      background: #2769dc;
      border: none;

      height: 2.8rem;
      border-radius: 0 10% 10% 0;

      ::v-deep span {
        font-size: 1.25rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        line-height: 0rem;
        color: #ffffff;
        opacity: 1;
      }

    }
  }
}

::v-deep .el-form-item {
  margin-right: 0 !important;
}

/deep/ .btn-prev,
.btn-next {
  background-color: #fff !important;
}

.center {
  transform: translateY(-5.75rem);
  width: 87.5rem;
  background-color: #F8FBFF;
  margin: 0 auto;
}

.choose {
  display: flex;
  flex-direction: column;
  // justify-content: space-around;
  // height: 40.375rem;
  background: #ffffff;
  box-shadow: 0rem 0.1875rem 1rem rgba(0, 0, 0, 0.08);
  opacity: 1;
  padding: 2.0625rem 1.625rem;

  .top {
    .line_box {
      margin-bottom: 1.5rem;
      display: flex;
      align-items: baseline;

      .line_box_left {
        min-width: 6.25rem;
        text-align: left;
        font-size: 1rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #4a4a4a;
        padding: 0.5rem 0.96rem;
      }

      .line_box_right {
        display: flex;
        overflow: hidden;
        flex: 1;

        span {
          white-space: nowrap;
          font-size: 1rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
          opacity: 1;
          padding: 0.375rem 1.125rem;
          text-align: left;
          cursor: pointer;
        }

        .isActiv {
          cursor: pointer;
          background: #2769dc;
          opacity: 1;
          color: #ffffff;
          border-radius: 0.3125rem;
          line-height: auto;
          padding: 0.375rem 1.125rem;
        }
      }

      .line_wrap {
        flex-wrap: wrap;
      }
    }
  }

  .botm {
    p {
      font-size: 1rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      opacity: 1;

      img {
        width: 0.4375rem;
        height: 0.75rem;
        transform: rotateZ(-90deg);
      }
    }
  }
}

.sort_count {
  display: flex;
  justify-content: space-between;
  height: 4.375rem;
  background: #ffffff;
  box-shadow: 0rem 0.1875rem 1rem rgba(0, 0, 0, 0.08);
  opacity: 1;
  margin-top: 1.25rem;
  align-items: center;
  padding-left: 1rem;

  .left {
    display: flex;

    .sortActiv {
      color: #999999;
    }

    span {
      font-size: 1rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #999;
      opacity: 1;
      cursor: pointer;
    }

    .left_sort {
      display: flex;
      align-items: center;

      div {
        cursor: pointer;
        margin-left: 2.3125rem;
      }

      img {
        margin-left: 0.5625rem;
        width: 0.5625rem;
        height: 0.75rem;
      }

      .fanzhuan {
        transform: rotate(180deg);
      }
    }
  }
}

.cenong {
  width: 100%;
  height: auto;
  margin-top: 0.625rem;
  overflow: hidden;
}

.cenong-left {
  float: left;
}

.cenong-right {
  float: right;
  width: 14.375rem;
  height: auto;
  margin-top: 1.875rem;
  padding: 0 0.9375rem;
  box-sizing: border-box;
  box-shadow: 0rem 0.1875rem 1rem rgba(0, 0, 0, 0.08);
}

.cenong-right-top {
  box-shadow: 0rem 0.1875rem 1rem rgba(0, 0, 0, 0.08);
  margin-top: 1.25rem;
  overflow: hidden;
  width: 20.875rem;
  float: right;
}

.crtone {
  height: 5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1.5rem;
  position: relative;
}

.crtone-d {
  display: flex;
  font-size: 1.25rem;
  align-items: center;
}

.crtone-d h3 {
  margin-left: 0.3125rem;
}

.crtone-d img {
  height: 1.5625rem;
}

.crtone-g a {
  color: #999;
  font-size: 1.125rem;
  right: 1.5rem;
  bottom: 1.875rem;
  line-height: 0.125rem;
}

.crtt-two {
  color: rgba(208, 208, 208, 1);
}

.crtt-two span {
  color: #f15916;
  font-family: Microsoft YaHei;
}

.crttwo {
  height: 16.625rem;
  border: 0.0625rem solid #eee;
  margin: 0 1.5rem 1.25rem;
  cursor: pointer;
}

.crttwoimg {
  width: 100%;
  height: 9.6875rem;
  background: #333333;
}

.crttwoimg img {
  width: 100%;
  height: 100%;
  float: left;
}

.crttwotext {
  text-align: left;
  padding: 0.7rem;
  line-height: 1.6875rem;
}

.crttwotext div {
  font-size: 1rem;
}

.crttwo-ji {
  color: rgba(208, 208, 208, 1);
  line-height: 2rem;
}

.crttwo-ji span {
  color: #8b8b8b;
}

.cet-cil {
  color: rgba(208, 208, 208, 1);
}

.cet-ciltwo {
  line-height: 2rem;
  color: rgba(208, 208, 208, 1);
}

.cet-span {
  color: rgba(139, 139, 139, 1);
}

.crttwotext .one {
  display: inline-block;
  width: 100%;
  font-size: 1.25rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-bottom: 0.3125rem;
}

.cenong-left-conent {
  margin-top: 1.25rem;
  overflow: hidden;
  padding-top: 1.25rem;
}

.clc-ui {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}

.clc-ui:after {
  content: "";
  width: 20.6875rem;
}

.clc-ui li {

  width: 20.6875rem;
  float: left;
  border-radius: 2%;
  border-bottom: 4px solid orange;
  box-shadow: 0rem 0.1875rem 1rem rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  min-height: 25.375rem;
  margin-bottom: 1.8125rem;
  cursor: pointer;

  &:hover {
    box-sizing: border-box;
    border-bottom: 4px solid blue;

    .name1 {
      color: #0561d2;
    }

    // background: linear-gradient(to bottom, #409aff, white);
    // background-color: #409aff;
  }
}

.clc-lia {
  position: relative;
  height: 60%;
  overflow: hidden;
  margin-bottom: 1.5625rem;
}

.clcig {
  position: absolute;
  top: 0.5rem;
  right: 0.0625rem;
  z-index: 9;
  width: 9.6875rem;
  height: 9.6875rem;
  background: #fff;
  border-radius: 50%;
}

.clc-lia img {
  z-index: 99;
  width: 9.375rem;
  height: 9.375rem;
  margin: 0.125rem auto 0;
}

.clc-lia-name {
  width: 14rem;
  height: 6.875rem;
  background: #f7f7f7;
  margin-top: 3.125rem;
  text-align: left;
  padding: 1.875rem 1.25rem;
  box-sizing: border-box;
  position: relative;
}

.lihead {
  width: 100%;
  height: 15rem;

  img {
    width: 100%;
    height: 15rem;
    display: block;

  }
}

.tags {
  width: 15rem;
  margin-top: 1rem;
  text-align: left;

  span {
    width: auto;
    padding: 0.2rem;
    color: #0561d2;
    height: 2rem;
    margin-right: 0.5rem;
    border-radius: 5px;
    border: 1.5px solid #0561d2;
  }
}

.brieIfntroduction {
  width: 17.5rem;
  height: 5rem;
  margin-top: 1rem;
  line-height: 1.8;
  text-overflow: ellipsis;
  text-align: left;
  overflow: hidden;
}

.video {
  width: 17rem;
  height: 10rem;
  margin-top: 1.5rem;

  video {
    width: 17rem;
    height: 10rem;
    display: block;
    margin: auto;
  }
}

.gang {
  width: 0.5rem;
  height: 3.25rem;
  position: absolute;
  top: 1.875rem;
  left: -0.17rem;
  background: #0561d2;
}

.clc-lia-name div b {
  display: block;
  font-size: 1.25rem;
  width: 7rem;
  height: 1.875rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.Adminis {
  display: block;
  color: #666;
  // height: 2rem;
}

#elcol {
  padding-right: 0.625rem !important;
}

#elco {
  max-width: 22.5rem !important;
}

.clncol {
  color: #999;
  margin-right: 42px;
}

.xiaoelse {
  text-align: center;
  display: block;
  margin: 0 auto;
}

.xiaoelse img {
  width: 20%;
}

.xiaoelse p {
  margin-top: 1.25rem;
  color: #cccccc;
  text-align: center;
}

.xinging {
  min-width: 1.25rem;
  margin-top: 5px;
}

.xinging span {
  display: inline-block;
  height: 0.9375rem;
  line-height: 0.75rem;
  margin-top: 0.5625rem;
  color: #999;
}

.guanzhi {
  width: 6.3125rem;
  height: 2.1875rem;
  line-height: 2.1875rem;
  color: #fff;
  text-align: center;
  background: #2769dc;
  margin: 1.875rem auto 0;
  font-size: 0.875rem;
  font-family: Microsoft YaHei;
}

.iscong {
  color: #333 !important;
}

.stingimg {
  display: inline-block;
  transform: rotateX(180deg);
}

.qunp {
  white-space: nowrap;
  font-size: 1rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  opacity: 1;
  padding: 0.375rem 1.125rem;
  text-align: left;
  cursor: pointer;
  height: 1.5rem;
}

.itemind {
  display: flex;
  flex-wrap: wrap;
}

.el-icon-search {
  color: white;
}

.detail_top_info_box {
  background: #E5EFFF;

  .top_info_box {
    height: 33.75rem;
    padding-top: 3.25rem;
    display: flex;
    justify-content: center;

    .top_info_box_left {
      width: 60rem;
      height: 33.75rem;
      background: #000;
      video{
        width: 100%;
        height: 100%;
      }
    }

    .top_info_box_right {
      padding: 1.88rem 0 0 0;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      background-color: #FFFFFF;
      width: 27.5rem;

      .school_logo {
        padding-left: 1.88rem;

        img {
          width: 15.88rem;
          height: 4.13rem;
        }
      }

      .school_top {
        font-weight: bold;
        font-size: 1.06rem;
        color: #2769DC;
        line-height: 1.75rem;
        margin-bottom: -1rem;
        margin-top: 1rem;
        padding-left: 1.88rem;
      }

      .school_txt {
        width: 23.75rem;
        height:68rem;
        color: #1E232D;
        font-size: 1rem;
        line-height: 1.88rem;
        margin: 1rem 0rem 0rem 1rem;
        text-align: left;
        overflow: hidden; /* 超出部分隐藏 */
        padding-left: 0.9rem;
      }
      .school_txt2{
                margin-left: 22rem;
          color: #2769DC;
          font-weight: bold;
          font-size: 1rem;
          cursor: pointer;
      }


      .school_txt_top, .school_txt_bottom {
        padding: 0 1.88rem;

        img {
          width: 23.72rem;
          height: 0.88rem;
        }
      }

      .school_student {
        display: flex;
        align-items: flex-end;
        justify-content: flex-end;
        width: 100%;
        height: 100%;

        img {
          width: 16.95rem;
          height: 6.38rem;
        }
      }
    }
  }

  .bottom_info_box {
    display: flex;

    .bottom_info_box_left {
      width: 17.19rem;
      height: 23.5rem;
      background: url("../../../assets/schoolInfo/bottom_left.png") no-repeat;
      background-size: 100%;
      margin-right: -1.88rem;
      margin-top: -1rem;
    }

    .bottom_info_box_center {
      position: relative;
      width: 87.5rem;
      height: 22.16rem;
      background: url("../../../assets/schoolInfo/bottom_center.png") no-repeat;
      background-size: 100%;
      z-index: 10;
      margin-top: 3rem;

      .bottom_info_box_center_txt {
        width: 68.25rem;
        height: 6.69rem;
        color: #232323;
        overflow: hidden; /* 超出部分隐藏 */
        font-size: 1rem;
        line-height: 1.88rem;
        margin: 1rem 5rem 0rem 4rem;
        text-align: left;
        padding: 6.8rem 4.6rem 4.6rem 4.6rem;

       
      }
    }
    .box_center_txt {
          margin-left:60rem;
          color: #2769DC;
          font-weight: bold;
          font-size: 1rem;
          cursor: pointer;
        }
    .bottom_info_box_right {
      width: 18.13rem;
      height: 23.5rem;
      background: url("../../../assets/schoolInfo/bottom_right.png") no-repeat;
      background-size: 100%;
      margin-left: -1.88rem;
      margin-top: 5rem;
    }
  }
}

.detail_body_info_box {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #F8FBFF;
  padding-top: 3.13rem;

  .detail_body_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 87.5rem;
    height: 3.72rem;
    border-bottom: 1px solid #E4E4E4;

    .detail_body_header_left {
      display: flex;
      align-items: center;

      .detail_header_icon {
        img {
          width: 2.78rem;
          height: 2.63rem;
        }
      }

      .detail_header_title {
        font-weight: 600;
        font-size: 2.13rem;
        color: #232323;
        margin-left: 0.19rem;
      }
    }

    .detail_body_header_right {
      cursor: pointer;
    }
  }

  .tech_box {
    display: flex;
    flex-wrap: wrap;
    width: 87.5rem;

    .tech_item {
      width: 20.56rem;
      height: 21.69rem;
      margin-right: 1.74rem;
      border-radius: 0.38rem 0.38rem 0.38rem 0.38rem;
      cursor: pointer;
      margin-top: 2.06rem;

      .tech_img {
        img {
          width: 20.56rem;
          height: 11.56rem;
        }
      }

      .tech_content {
        background: #FFFFFF;
        text-align: left;
        padding-bottom: 1rem;
        border-radius: 0 0 0.38rem 0.38rem;

        .tech_name {
          padding: 1.5rem 1.69rem 0 1.69rem;
          font-weight: 600;
          font-size: 1.25rem;
          color: #232323;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 1;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          margin-bottom: 1rem;
        }

        .tech_desc {
          padding-left: 1.69rem;
          color: #7A7A7A;
          font-size: 0.88rem;
          line-height: 1.5rem;
        }
      }

      .tech_border {
        width: 100%;
        height: 0.25rem;
        background-color: #FF6D00;
        border-radius: 0 0 0.38rem 0.38rem;
      }

      &:hover {
        margin-top: 1.5rem;

        .tech_name {
          color: #046EE6;
        }

        .tech_border {
          background-color: #2769DC;
        }
      }

      &:nth-child(4n) {
        margin-right: 0;
      }
    }
  }

  .require_type_box {
    display: flex;
    flex-wrap: wrap;
    width: 87.5rem;
    margin-top: 1.88rem;
    margin-bottom: 1.06rem;

    .require_type_item {
      display: flex;
      flex-direction: column;
      align-items: center;
      background: #FFFFFF;
      color: #2769DC;
      margin-right: 0.94rem;
      margin-bottom: 2rem;
      cursor: pointer;

      .require_type_item_txt {
        display: flex;
        align-items: center;
        padding: 0 0.63rem;
        border-radius: 0.25rem 0.25rem 0.25rem 0.25rem;
        border: 0.06rem solid #2769DC;
        height: 1.88rem;
      }

      .require_type_item_icon {
        margin-bottom: -0.44rem;

        img {
          display: none;
          width: 0.88rem;
          height: 0.44rem;
        }
      }
    }

    .require_active {
      .require_type_item_txt {
        background: #2769DC;
        color: #fff;
        
      }

      .require_type_item_icon {
        margin-bottom: -0.44rem;

        img {
          display: inherit;
          width: 0.88rem;
          height: 0.44rem;
        }
      }
    }
  }

  .require_box {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(3, 1fr);
    background: url("../../../assets/schoolInfo/require_bg.png") no-repeat;
    width: 87.5rem;
    height: 28.38rem;
    background-size: 100%;
    padding: 1.63rem;

    .require_item {
      display: flex;
      width: 28.25rem;
      height: 7.5rem;
      background: #F8FBFF;
      margin-right: 1.25rem;
      border-radius: 0.38rem 0.38rem 0.38rem 0.38rem;
      cursor: pointer;

      .require_img {
        img {
          width: 13.31rem;
          height: 7.5rem;
        }
      }

      .require_content {
        padding: 1.25rem 1.3rem;
        text-align: left;

        .require_name {
          font-weight: 600;
          font-size: 1.13rem;
          color: #232323;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 1;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          margin-bottom: 1rem;
        }

        .require_desc {
          font-size: 0.88rem;
          color: #7A7A7A;
          line-height: 1.5rem;
        }
      }

      &:nth-child(3n) {
        margin-right: 0;
      }

      &:hover {
        .require_name {
          color: #046EE6;
        }
      }
    }
  }

  .dev_box {
    display: flex;
    flex-wrap: wrap;
    width: 87.5rem;
    margin-top: 1.85rem;

    .dev_item {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 20.56rem;
      margin-right: 1.75rem;
      cursor: pointer;

      .dev_img {
        img {
          width: 20.56rem;
          height: 15.44rem;
        }
      }

      .dev_content {
        position: relative;
        z-index: 10;
        width: 18.69rem;
        background: #FFFFFF;
        box-shadow: 0rem 0.31rem 0.63rem 0.06rem #E6ECF6;
        border-radius: 0.38rem 0.38rem 0.38rem 0.38rem;
        text-align: left;
        margin-top: -2rem;
        padding-bottom: 0.5rem;
        .dev_name {
          font-weight: 600;
          font-size: 1.25rem;
          color: #232323;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 1;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          margin-bottom: 0.5rem;
          padding: 1.2rem 1.88rem 0 1.88rem;

        }
        .dev_name_bar{
          width: 3.13rem;
          height: 0.25rem;
          background: #FFCC00;
          margin: 0 1.88rem 1rem 1.88rem;
        }
        .dev_desc{
          padding: 0 1.88rem;
          font-size: 0.94rem;
          color: #7A7A7A;
          line-height: 1.25rem;
          margin-bottom: 0.5rem;
        }
      }

      &:nth-child(4n) {
        margin-right: 0;
      }
      &:hover{
        .dev_content{
          background: linear-gradient( 180deg, #5A96FF 0%, #2769DC 100%);
          .dev_name,.dev_desc{
            color: #fff;
          }
        }
      }
    }
  }

  .expert_box{
    display: flex;
    width: 87.5rem;
    margin-top: 3rem;
    margin-bottom: 6rem;
    .expert_item{
      display: flex;
      background-image: url("../../../assets/schoolInfo/expert_bg1.png");
      width: 20.56rem;
      height: 12.38rem;
      background-size: cover;
      margin-right: 1.75rem;
      cursor: pointer;
      &:nth-child(4n) {
        margin-right: 0;
      }
      &:hover{
        width: 20.56rem;
        height: 12.38rem;
        background-size: cover;
        background-image: url("../../../assets/schoolInfo/expert_active_bg1.png");
        .expert_content{
          .expert_name{
            color: #FFFFFF;
            span{
              color: #FFFFFF;
            }
          }
          .expert_name_bar{
            background: #FFFFFF;
          }
          .expert_desc_box{
            color: #FFFFFF;
          }
        }
      }
      .expert_img{
        margin-left: 1.88rem;
        img{
          width: 7.5rem;
          height: 10.5rem;
        }
      }
      .expert_content{
        margin-left: 1.5rem;
        text-align: left;
        .expert_name{
          font-weight: 600;
          font-size: 1.25rem;
          color: #232323;
          margin-top: 3.3rem;
          span{
            font-weight: 400;
            font-size: 0.94rem;
            color: #232323;
            margin-left: 0.8rem;
          }
        }
        .expert_name_bar{
          position: relative;
          z-index: 10;
          width: 1.88rem;
          height: 0.25rem;
          background: #232323;
          margin-top: 0.5rem;
        }
        .expert_desc_box{
          border-top:1px solid #fff;
          margin-top: -1px;
          font-size: 0.88rem;
          color: #232323;
          line-height: 1.38rem;
          padding-top: 1rem;
        }
      }
    }
  }
}

.detail_bottom_info_box{
  background: #F8FBFF;
  padding-bottom: 3.13rem;
  .detail_bottom_info_box_body{
    display: flex;
    width: 87.5rem;
    max-width: 87.5rem;

    background: #FFFFFF;
    box-shadow: 0rem 0.31rem 0.63rem 0.06rem #E6ECF6;
    border-radius: 0.38rem 0.38rem 0.38rem 0.38rem;
    margin: 0 auto;
    .detail_bottom_info_box_left{
      padding: 1.88rem;
      width: 55rem;
      text-align: left;
      .detail_bottom_info_box_left_video{
        width: 55rem;
        height: 31.5rem;
        background-color: #333333;
        border-radius: 0.38rem;
        video{
          width: 100%;
          height: 100%;
        }
      }
      .detail_bottom_info_box_left_name{
        font-weight: 600;
        font-size: 1.25rem;
        color: #232323;
        line-height: 1.75rem;
        margin-top: 1.56rem;
      }
      .detail_bottom_info_box_left_time{
        font-size: 0.81rem;
        color: #9F9F9F;
        line-height: 1.88rem;
        span{
          margin-left: 2rem;
        }
      }
      .detail_bottom_info_box_left_txt{
        font-weight: 400;
        font-size: 0.88rem;
        color: #7A7A7A;
        line-height: 1.56rem;
      }
      .detail_bottom_info_box_left_enter{
        font-size: 0.88rem;
        color: #7A7A7A;
        line-height: 1.75rem;
        margin-top: 1rem;
      }
    }
    .detail_bottom_info_box_right{
      padding: 1.88rem 1.88rem 1.88rem 0rem;
      flex: 1;
      .bottom_info_box_item{
        display: flex;
        margin-bottom: 1.25rem;
        .bottom_info_box_item_left{
          width: 11.38rem;
          min-width: 11.38rem;
          height: 6.5rem;
          border-radius: 0.38rem 0.38rem 0.38rem 0.38rem;
          background-color: #9F9F9F;
          margin-right: 0.56rem;
          video{
            width: 100%;
            height: 100%;
          }
        }
        .bottom_info_box_item_right{
          text-align: left;
          padding-right: 1.88rem;
          .bottom_info_box_item_right_name{
            font-weight: 600;
            font-size: 1.13rem;
            color: #232323;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            margin-bottom: 0.75rem;
            min-height: 3.13rem;
          }
          .bottom_info_box_item_right_desc{
            font-size: 0.81rem;
            color: #9F9F9F;
            line-height: 1.56rem;
          }
        }
      }
    }
    .scrollbar_bottom{
      height: 44rem;
      ::v-deep .el-scrollbar__wrap{
        overflow-x: hidden !important;
      }
      ::v-deep  .el-scrollbar__bar.is-vertical{
        opacity: 1;
        background-color: #EDF0F5;
      }
      ::v-deep .el-scrollbar__thumb{
        background-color: #046EE6 !important;
      }
    }
  }
}

::v-deep .open_more_dialog_box{
  .el-dialog__header{
    padding: 0;
  }
  .el-dialog__body{
    padding: 0;
  }
  .open_more_dialog{
    .open_more_dialog_top{
      width: 58.75rem;
      height: 10.44rem;
      background: linear-gradient( 180deg, #4D8EFF 0%, #6BA2FF 46%, #B5D0FF 100%);
      font-weight: 600;
      font-size: 1.88rem;
      color: #FFFFFF;
      text-align: center;
      .open_more_dialog_name{
        padding-top: 3.5rem;
      }
      &:before {
        top: 8.36rem;;
        left: 0;
        right: 0;
        width: 100%;
        border-radius: 50%; // 控制弧度效果 越大弧度越自然
        background: #FFFFFF;
        content: "";
        height: 4rem; // 控制椭圆高度
        position: absolute; // 关键***
      }
    }
    .open_more_dialog_footer{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 58.75rem;
      height: 4.69rem;
      background: #FFFFFF;
      box-shadow: 0rem -0.25rem 0.63rem 0.06rem rgba(39,105,220,0.1);
      .open_more_dialog_btn{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 12.13rem;
        height: 2.13rem;
        background: linear-gradient( 90deg, #4D8EFF 0%, #B5D0FF 100%);
        border-radius: 1.06rem 1.06rem 1.06rem 1.06rem;
        font-size: 0.94rem;
        color: #FFFFFF;
        cursor: pointer;
      }
    }
    .open_more_dialog_body{
      padding: 1rem 2.5rem 0 2.5rem;
      text-align: left;
      font-size: 0.94rem;
      color: #1E232D;
      line-height: 1.88rem;
      .dialog_body_txt{
        padding-right: 1.44rem;
      }
    }
    .scrollbar_dialog{
      height: 22.19rem;
      font-size: 0.94rem;
      color: #1E232D;

      .el-scrollbar__wrap{
        overflow-x: hidden !important;
      }
      .el-scrollbar__bar.is-vertical{
        opacity: 1;
      }
      .el-scrollbar__thumb{
        background-color: #D6E6FF !important;
      }
    }
  }
}
.link_c_gray{
  color: #7E7E7E;
}
.expert_desc{
  width: 8rem;
  height: 1.5rem;
  overflow: hidden;
}
</style>
